// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L80QO8gXh6gCdBvLTSTq{flex-direction:column;flex:1;align-self:center;width:100%;max-width:620px;padding:0 16px;display:flex}@media (min-width:992px){.L80QO8gXh6gCdBvLTSTq{max-width:760px}}.z_L80yxh3HgjGqzc4Y_s{flex-direction:column;gap:4px;display:flex}.syghBJoKGjojNdSe_VuJ{color:var(--content-primary-tertiary)}.uDNS9mrDNMoU2h87x7ri{height:inherit;flex-direction:column;flex-grow:1;display:flex}.pYejSASXfwoZQmcRTuaP{min-width:109px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `L80QO8gXh6gCdBvLTSTq`,
	"header": `z_L80yxh3HgjGqzc4Y_s`,
	"headerDescription": `syghBJoKGjojNdSe_VuJ`,
	"wrap": `uDNS9mrDNMoU2h87x7ri`,
	"guideButton": `pYejSASXfwoZQmcRTuaP`
};
export default ___CSS_LOADER_EXPORT___;
